import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", {

  plugins: ["InvocaApp", "ModalDialog", "Form"]

});
